import { UserCommunicationPreference, UserGroup } from '@provision/entity-types';
import type { ConversationAssigneeGroup, UserSettingValueMap } from 'src/graphql';
import { create } from 'zustand';

export interface MappedUserData {
  id: string;
  userId: string;
  partnerId: number;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: string;
  avatarFileKey?: string;
  conversationAssigneeGroups: ConversationAssigneeGroup[];
  userGroups: UserGroup[];
  userCommunicationPreferences: UserCommunicationPreference[];
  userSettingValueMap: UserSettingValueMap;
}

type UserState = {
  user: MappedUserData | null;
  setUser: (user: MappedUserData | null) => void;
  removeUser: () => void;
};

export const useUserStore = create<UserState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  removeUser: () => set({ user: null }),
}));

export const selectUser = (s: UserState) => s.user;
